import React from "react"
import ButtonToolbar from "react-bootstrap/lib/ButtonToolbar"
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup'
import Button from 'react-bootstrap/lib/Button'

class ReportOptions extends React.Component {
    constructor(props) {
        super(props)

        const reportOption = this.props.reportOption || localStorage.getItem("reportOption")
        this.state = {
            reportOption: reportOption || "AT_LEAST",
        }
    }

    onAllClick = () => {
        this.setState(
            {
                reportOption: "AT_LEAST",
            }, 
            () => localStorage.setItem("reportOption", "AT_LEAST"),
        )
        this.props.setReportOption("AT_LEAST")
    }

    onAnyClick = () => {
        this.setState(
            {
                reportOption: "ANY",
            }, 
            () => localStorage.setItem("reportOption", "ANY"),
        )
        this.props.setReportOption("ANY")
    }

    render() {
        const { reportOption } = this.state
        return (
            <ButtonToolbar style={{width: "115px"}}>
                <ButtonGroup>
                    <Button onClick={this.onAllClick} active={reportOption === 'AT_LEAST'}>
                        All
                    </Button>
                    <Button onClick={this.onAnyClick} active={reportOption === 'ANY'}>
                        Any
                    </Button>
                </ButtonGroup>
            </ButtonToolbar>
        )
    }
}

export default ReportOptions


// WEBPACK FOOTER //
// ./src/components/report_options.jsx